import { useState, useEffect, useRef } from 'react'

const Loader = ({ size='lg', color }) => {
  const [dots, setDots] = useState([false, false, false])
  const timeoutsRef = useRef([])

  useEffect(() => {
    const cycle = () => {
      timeoutsRef.current.forEach(timeout => clearTimeout(timeout))
      timeoutsRef.current = []

      setDots([false, false, false])
      timeoutsRef.current.push(setTimeout(() => setDots([true, false, false]), 0))
      timeoutsRef.current.push(setTimeout(() => setDots([true, true, false]), 500))
      timeoutsRef.current.push(setTimeout(() => setDots([true, true, true]), 1000))
      timeoutsRef.current.push(setTimeout(() => setDots([false, false, false]), 1500))
    }

    cycle()
    const interval = setInterval(cycle, 2000)

    return () => {
      clearInterval(interval)
      timeoutsRef.current.forEach(timeout => clearTimeout(timeout))
    }
  }, [])

  const getSizeClasses = () => {
    return 'w-1.5 h-1.5'
  }

  const getColorClass = () => {
    if (!color) return 'bg-gray-800'
    if (color === 'border-white') return 'bg-white'
    if (color.startsWith('text-')) return color.replace('text-', 'bg-')
    if (color.startsWith('border-')) return color.replace('border-', 'bg-')
    if (color.startsWith('bg-')) return color
    return `bg-${color}`
  }

  const dotClasses = `rounded-full ${getSizeClasses()} ${getColorClass()} transition-opacity duration-300 flex-shrink-0`

  return (
    <div className="flex items-center justify-center gap-1">
      <div className={`${dotClasses} ${dots[0] ? 'opacity-100' : 'opacity-0'}`}></div>
      <div className={`${dotClasses} ${dots[1] ? 'opacity-100' : 'opacity-0'}`}></div>
      <div className={`${dotClasses} ${dots[2] ? 'opacity-100' : 'opacity-0'}`}></div>
    </div>
  )
}

export default Loader
